export const DomElementIds = {
    bottomSheetPortalId: 'navi-bottom-sheet-portal',
    drawerPortalId: 'navi-drawer-portal',
};

export const IsWindow = typeof window !== 'undefined';
